var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.314,
    height: 43.527,
    viewBox: "0 0 151.314 43.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.282,
    y1: 0.153,
    x2: 1.034,
    y2: 0.847,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006097"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.152 16.434a8.027 8.027 0 00-2.088-.222c-2.532 0-5.241 2.051-5.241 4.583v12.073h-5.774V11.326h5.552v2.176a8.063 8.063 0 016.263-2.621 11.773 11.773 0 011.954.178zM61.682.002a3.688 3.688 0 11-3.775 3.687A3.7 3.7 0 0161.682.002zm2.887 32.868h-5.774V11.326h5.774v21.542zm17.056-21.989a9.859 9.859 0 00-6.307 2.178v-1.733h-5.553v32.2h5.775V31.359a9.084 9.084 0 005.775 1.955 10.927 10.927 0 008.172-3.643 11.523 11.523 0 002.708-7.55c0-6.353-4.708-11.24-10.57-11.24zm-.7 17.19a5.933 5.933 0 110-11.865 5.946 5.946 0 010 11.865zm46.315 4.797h-5.774V1.332h5.774v31.536zm23.541-3.42a11.689 11.689 0 01-8.839 3.864c-6.44 0-11.282-4.442-11.282-11.193 0-6 4.086-11.238 10.483-11.238 5.952 0 10.172 5.019 10.172 11.015a9.481 9.481 0 01-.133 1.644h-14.926a5.656 5.656 0 005.819 5.108 7.623 7.623 0 005.419-2.487zm-5.37-10.127a4.3 4.3 0 00-4.264-3.775 4.673 4.673 0 00-4.619 3.775zm-37.935-8.44a9.859 9.859 0 00-6.307 2.178v-1.733h-5.553v32.2h5.775V31.359a9.084 9.084 0 005.775 1.955 10.927 10.927 0 008.172-3.643 11.523 11.523 0 002.708-7.55c0-6.353-4.708-11.24-10.57-11.24zm-.7 17.19a5.933 5.933 0 110-11.865 5.946 5.946 0 010 11.865z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.493 62.329a8.914 8.914 0 00-4.226-1.022 2.994 2.994 0 01-3.04-3.044 3.085 3.085 0 013.041-3.044 8.914 8.914 0 004.225-1.019 7.7 7.7 0 10-11.552-6.669 8.844 8.844 0 001.208 4.139 3 3 0 01-1.1 4.187 3.093 3.093 0 01-4.172-1.142 8.851 8.851 0 00-2.977-3.121 7.7 7.7 0 100 13.339 8.847 8.847 0 002.981-3.117 3 3 0 014.173-1.143 3.1 3.1 0 011.1 4.188A8.842 8.842 0 0046.941 69a7.7 7.7 0 1011.552-6.669z",
    transform: "translate(-28.347 -37.309)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.3cd83de6d4239917265c046ba7ead867.svg";
export { ForwardRef as ReactComponent };